import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/BackButton";
import { UserContext } from "../context/UserContext";
import { API_URL } from "../config";

function Settings() {
    const navigate = useNavigate();

    // 🔥 FIX: Context se 'setUser' hatakar naya 'logout' function le liya
    const { user, loading, logout } = useContext(UserContext);

    // Modals State
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false); // 🔥 NAYA: Success Modal State

    // Delete Account States
    const [deletePassword, setDeletePassword] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);

    // --- LOGOUT LOGIC ---
    const handleLogout = () => {
        logout(); // 🔥 MAGIC: Ab ye context wala logout chalega aur sab cache (Referral + User) saaf kar dega
        sessionStorage.clear(); // Safety ke liye isko rehne diya
        navigate("/auth");
    };

    // --- DELETE ACCOUNT LOGIC ---
    const handleDeleteAccount = async () => {
        if (!deletePassword) {
            return alert("Please enter your password to confirm deletion.");
        }

        setIsDeleting(true);
        try {
            const token = localStorage.getItem("token");
            const res = await fetch(`${API_URL}/api/auth/request-delete`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ password: deletePassword })
            });

            const data = await res.json();

            if (res.ok && data.success) {
                setShowDeleteModal(false);
                setDeletePassword("");
                setShowSuccessModal(true); // 🔥 Alert ki jagah apna Premium Modal khulega
            } else {
                alert(data.message || "Incorrect password or request failed.");
            }
        } catch (error) {
            console.error("Delete Request Error:", error);
            alert("Network error, please try again later.");
        } finally {
            setIsDeleting(false);
        }
    };

    // Helper Component for List Items
    const SettingItem = ({ icon, color, title, subtitle, action, onClick, isDanger }) => (
        <div
            className={`d-flex align-items-center justify-content-between p-3 mb-3 rounded-4 shadow-sm bg-white hover-scale ${isDanger ? 'border border-danger' : ''}`}
            style={{ cursor: onClick ? "pointer" : "default" }}
            onClick={onClick}
        >
            <div className="d-flex align-items-center gap-3">
                <div className={`rounded-circle d-flex align-items-center justify-content-center text-white`}
                    style={{ width: '45px', height: '45px', background: color, boxShadow: `0 4px 10px ${color}60` }}>
                    <i className={`bi ${icon} fs-5`}></i>
                </div>
                <div>
                    <h6 className={`fw-bold mb-0 ${isDanger ? 'text-danger' : 'text-dark'}`}>{title}</h6>
                    <small className="text-muted">{subtitle}</small>
                </div>
            </div>
            <div>{action}</div>
        </div>
    );

    // SHIMMER LOADER
    if (loading) return (
        <div style={{ minHeight: "100vh", background: "#f4f6f9" }}>
            <div className="pb-5 pt-4 px-3 position-relative placeholder-glow"
                style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", borderBottomLeftRadius: "35px", borderBottomRightRadius: "35px", height: "260px" }}>
                <div className="d-flex justify-content-between align-items-center mb-5">
                    <span className="placeholder col-1 bg-white opacity-25 rounded"></span>
                </div>
                <div className="text-center mt-4">
                    <div className="placeholder rounded-circle bg-white opacity-25 mb-3 mx-auto" style={{ width: "90px", height: "90px" }}></div>
                    <span className="placeholder col-4 bg-white opacity-25 rounded d-block mx-auto mb-2"></span>
                    <span className="placeholder col-3 bg-white opacity-25 rounded d-block mx-auto"></span>
                </div>
            </div>
            <div className="container px-3 mt-4 placeholder-glow">
                {[1, 2, 3].map(i => (
                    <div key={i} className="card border-0 shadow-sm mb-3 rounded-4 p-3 d-flex flex-row align-items-center gap-3" style={{ height: '80px' }}>
                        <span className="placeholder rounded-circle bg-secondary opacity-10" style={{ width: '45px', height: '45px' }}></span>
                        <div className="flex-grow-1">
                            <span className="placeholder col-5 bg-secondary opacity-10 rounded mb-1"></span>
                            <span className="placeholder col-3 bg-secondary opacity-10 rounded d-block"></span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    // Safety Check
    if (!user) {
        navigate('/login');
        return null;
    }

    return (
        <div style={{ background: "#f4f6f9", paddingBottom: "30px", fontFamily: "'Poppins', sans-serif" }}>

            {/* === HERO HEADER === */}
            <div
                className=" px-3 py-2 position-relative overflow-hidden"
                style={{
                    background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)",
                    borderBottomLeftRadius: "40px",
                    borderBottomRightRadius: "40px",
                    // height: "280px",
                    boxShadow: "0 10px 20px rgba(128,0,0,0.15)"
                }}
            >
                <div className="position-relative z-1">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <BackButton className="text-white bg-transparent border-0" />
                        <div style={{ width: 30 }}></div>
                    </div>

                    <div className="text-center " style={{ marginTop: "-10px" }} >
                        <div className="d-inline-flex align-items-center gap-2 bg-white bg-opacity-10 px-4 py-2 rounded-pill border border-white border-opacity-25 shadow-sm backdrop-blur mb-3">
                            <i className="bi bi-gear-wide-connected text-white fs-5"></i>
                            <h4 className="fw-bold text-white mb-0" style={{ letterSpacing: "1px" }}>Settings</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container px-3 mt-4">

                {/* === SECTION 1: LEGAL & POLICIES === */}
                <h6 className="fw-bold text-uppercase small ls-1 mb-3 text-muted ms-2">Legal & Policies</h6>

                <SettingItem
                    icon="bi-file-earmark-text-fill" color="#4e73df"
                    title="Terms & Conditions" subtitle="App rules and guidelines"
                    action={<i className="bi bi-chevron-right text-muted"></i>}
                    onClick={() => navigate('/terms-and-conditions')}
                />
                <SettingItem
                    icon="bi-shield-check" color="#1cc88a"
                    title="Privacy Policy" subtitle="How we protect your data"
                    action={<i className="bi bi-chevron-right text-muted"></i>}
                    onClick={() => navigate('/privacy-policy')}
                />
                <SettingItem
                    icon="bi-trophy-fill" color="#f6c23e"
                    title="Fair Play Policy" subtitle="Ensure a level playing field"
                    action={<i className="bi bi-chevron-right text-muted"></i>}
                    onClick={() => navigate('/fair-play-policy')}
                />

                {/* === SECTION 2: COMMUNITY & SUPPORT === */}
                <h6 className="fw-bold text-uppercase small ls-1 mb-3 mt-4 text-muted ms-2">Community</h6>

                <SettingItem
                    icon="bi-telegram" color="#0088cc"
                    title="Join Telegram Group" subtitle="Get latest tips & updates"
                    action={<i className="bi bi-box-arrow-up-right text-primary"></i>}
                    onClick={() => window.open("https://telegram.org", "_blank")}
                />
                <SettingItem
                    icon="bi-instagram" color="#e1306c"
                    title="Follow on Instagram" subtitle="@win11fantasy"
                    action={<i className="bi bi-box-arrow-up-right text-primary"></i>}
                    onClick={() => window.open("https://instagram.com", "_blank")}
                />


                {/* === SECTION 3: ACCOUNT & SECURITY === */}
                <h6 className="fw-bold text-uppercase small ls-1 mb-3 mt-4 text-muted ms-2">Account Actions</h6>

                <SettingItem
                    icon="bi-box-arrow-right" color="#800000"
                    title="Log Out" subtitle="Sign out from this device"
                    action={<i className="bi bi-chevron-right text-muted"></i>}
                    onClick={() => setShowLogoutModal(true)}
                />
                <SettingItem
                    icon="bi-trash3-fill" color="#dc3545"
                    title="Delete Account" subtitle="Permanently delete your data"
                    action={<i className="bi bi-exclamation-circle text-danger"></i>}
                    onClick={() => setShowDeleteModal(true)}
                    isDanger={true}
                />

                {/* Version Info */}
                <div className="text-center mb-2">
                    <img src="https://res.cloudinary.com/drh0n1wjy/image/upload/v1774200970/Gemini_Generated_Image_1ttmnf1ttmnf1ttm-removebg-preview_gf1exb.png" alt="Logo" style={{ width: "60px", opacity: 0.5 }} className="mb-2" />
                    <br />
                    <small className="fw-bold text-muted">Win11</small><br />
                    <small className="opacity-50 text-dark">Version 1.0.0</small>
                </div>

            </div>

            {/* ========================================================= */}
            {/* MODALS SECTION */}
            {/* ========================================================= */}

            {/* 1. LOGOUT MODAL */}
            {showLogoutModal && (
                <>
                    <div className="modal-backdrop fade show" style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.7)" }}></div>
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered px-3">
                            <div className="modal-content border-0 shadow-lg rounded-4 p-4 text-center animate-up">
                                <div className="mb-3">
                                    <div className="bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                                        <i className="bi bi-box-arrow-right display-4"></i>
                                    </div>
                                </div>
                                <h4 className="fw-bold mb-2">Log Out?</h4>
                                <p className="text-muted mb-4 px-2">Are you sure you want to sign out from Win11 on this device?</p>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-light flex-fill rounded-pill py-3 fw-bold" onClick={() => setShowLogoutModal(false)}>Cancel</button>
                                    <button className="btn btn-danger flex-fill rounded-pill py-3 fw-bold shadow-sm" onClick={handleLogout}>Yes, Log Out</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* 2. DELETE ACCOUNT MODAL */}
            {showDeleteModal && (
                <>
                    <div className="modal-backdrop fade show" style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.8)" }}></div>
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered px-3">
                            <div className="modal-content border-0 shadow-lg rounded-4 p-4 text-center animate-up border border-danger border-2">
                                <div className="mb-3">
                                    <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center shadow" style={{ width: '80px', height: '80px' }}>
                                        <i className="bi bi-exclamation-triangle-fill display-4"></i>
                                    </div>
                                </div>
                                <h4 className="fw-bold mb-2 text-danger">Delete Account</h4>
                                <p className="text-muted small mb-4 px-2">
                                    Warning: This action cannot be undone. You will lose all your data, wallet balance, and match history permanently.
                                </p>
                                <div className="form-floating mb-4 text-start">
                                    <input
                                        type="password"
                                        className="form-control border-danger shadow-sm rounded-3"
                                        placeholder="Password"
                                        value={deletePassword}
                                        onChange={(e) => setDeletePassword(e.target.value)}
                                    />
                                    <label className="text-danger fw-bold"><i className="bi bi-shield-lock-fill me-2"></i>Enter Password to Confirm</label>
                                </div>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-light flex-fill rounded-pill py-3 fw-bold" onClick={() => { setShowDeleteModal(false); setDeletePassword(""); }}>Cancel</button>
                                    <button
                                        className="btn btn-danger flex-fill rounded-pill py-3 fw-bold shadow"
                                        onClick={handleDeleteAccount}
                                        disabled={isDeleting}
                                    >
                                        {isDeleting ? "Processing..." : "Permanently Delete"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* 🔥 3. SUCCESS MODAL (Replaces default Alert) */}
            {showSuccessModal && (
                <>
                    <div className="modal-backdrop fade show" style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.8)" }}></div>
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered px-3">
                            <div className="modal-content border-0 shadow-lg rounded-4 p-4 text-center animate-bounce">
                                <div className="mb-3 text-success">
                                    <i className="bi bi-check-circle-fill display-1"></i>
                                </div>
                                <h4 className="fw-bold mb-2">Request Received</h4>
                                <p className="text-muted small mb-4 px-2">
                                    Your account will be permanently deleted within 12 to 24 hours. You will now be logged out of your account for security purposes.
                                </p>
                                <button
                                    className="btn w-100 rounded-pill py-3 fw-bold shadow-sm text-white"
                                    style={{ background: "#800000" }}
                                    onClick={() => {
                                        setShowSuccessModal(false);
                                        handleLogout(); // 🔥 User ab Logout hoga OK dabane par
                                    }}
                                >
                                    Okay, Log Out
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <style>{` 
                .ls-1 { letter-spacing: 1px; } 
                .backdrop-blur { backdrop-filter: blur(8px); } 
                .hover-scale { transition: transform 0.2s ease; }
                .hover-scale:hover { transform: scale(1.02); }
                .animate-up { animation: fadeInUp 0.4s ease-out both; }
                .animate-bounce { animation: bounceIn 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) both; }
                
                @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes bounceIn {
                    0% { transform: scale(0.5); opacity: 0; }
                    80% { transform: scale(1.05); opacity: 1; }
                    100% { transform: scale(1); opacity: 1; }
                }
            `}</style>
        </div>
    );
}

export default Settings;